export function StatCard({ icon: Icon, label, value, meta, accent = "blue", testId }) {
  return <div className={`stat-card accent-${accent}`} data-testid={testId}>
    <div className="stat-icon"><Icon size={19} /></div><div><span>{label}</span><strong>{value}</strong><small>{meta}</small></div>
  </div>;
}
